<template>
  <div>
    <v-dialog v-model="notificationDialog" max-width="600">
      
      <v-row>
        <v-col>
          <v-card>
            <v-system-bar flat color="white">
              <v-spacer></v-spacer>
              <v-btn icon class="mt-3" @click="notificationDialog=false"><v-icon color="red">mdi-close</v-icon></v-btn>
            </v-system-bar>
            <v-card-title class="pt-0 pb-0">My Notifications</v-card-title>
            <v-row v-for="item in RecentNotifications" :key="item" no-gutters>
              <v-col cols="1">
                <v-card-text>
                  <v-icon style="color:#40e0d0">mdi-human-greeting</v-icon>
                </v-card-text>
              </v-col>
              <v-col cols="11">
                <v-card-text>
                  <p class="mb-0">{{item.body}}</p>
                  <v-sub-header class="grey--text" >{{item.date_sent}}</v-sub-header>
                </v-card-text>
              </v-col>
            </v-row>
            <div class="text-center">
              <button @click="viewNotifications()" class="btn" style="color:#033953">View All Notifications</button>
            </div>
          </v-card>
        </v-col>
        
      </v-row>
    </v-dialog>
    <nav>
      <v-app-bar app height='60px' flat color="white">
        <v-app-bar-nav-icon class="green--text hidden-md-and-up" @click="drawer = !drawer"></v-app-bar-nav-icon>
        <h3 class="ma-3">GreenFarms</h3>
        <v-spacer></v-spacer>
        <v-btn icon class="ma-3" @click="markNotification()">
          <v-badge color="red" top overlap >
            <template v-slot:badge>{{Count}}</template>
            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-btn>
        <v-btn icon class="ma-3">
            <v-icon @click="logout()" color="#033953">
              mdi-power
            </v-icon>
        </v-btn>
      </v-app-bar>

      <v-navigation-drawer
        v-model="drawer"
        app
        style="background-color:white"
        >
    

        <v-layout column align-center>
          <v-flex class="mt-3">
              <div class="mt-3">
                <v-list-item-avatar>
                  <v-img :src='getImageUrl(userById.profile_img_url)'  ></v-img>
                </v-list-item-avatar>
              </div>
            
          </v-flex>
        </v-layout>
        <v-layout column align-center>
          <v-flex class="white--text" dark>
              <v-list-item link class="">
                  <v-list-item-content>
                      <v-list-item-title class="text-center black--text">Welcome, {{userById.firstname}}</v-list-item-title>
                  </v-list-item-content>
              </v-list-item>
          </v-flex>
        </v-layout>
        
        <v-list dense class="mt-4">
          <v-list-item router-link to="/" >
            <v-list-item-icon>
                <v-icon color="#48c074">mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="font-size:14px" >
                Home
            </v-list-item-title> 
          </v-list-item>
          <v-list-item router-link to="/dashboard/admin" >
            <v-list-item-icon>
                <v-icon color="#48c074">mdi-apps</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="font-size:14px" >
                Dashboard
            </v-list-item-title> 
          </v-list-item>
          
          <v-list-item router-link to="/profile/admin" >
            <v-list-item-icon>
              <v-icon color="#48c074">mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="font-size:14px" >
              My Account
            </v-list-item-title> 
          </v-list-item>
          <v-list-item router-link to="/manageusers" >
            <v-list-item-icon>
                <v-icon color="#48c074">mdi-account-group</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="font-size:14px" >
                Manage Users
            </v-list-item-title> 
          </v-list-item>
          <v-list-item router-link to="/farms/admin" >
            <v-list-item-icon>
                <v-icon color="#48c074">mdi-tree-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title style="font-size:14px" >
              Farms
            </v-list-item-title> 
          </v-list-item>
          
          
        </v-list>
        <template v-slot:append>
          <div class="pa-2">
            <v-btn block dark color="#48c074" class="text-none" @click='logout()'>
               <v-icon left>mdi-power</v-icon> Log out</v-btn>
          </div>
      </template>
      </v-navigation-drawer>
  </nav>
  </div>
</template>

<script>
  export default {
    data(){
      return{
        drawer: null,
        notificationDialog:false,
        notificationHeaders:[
          {text: "", value:'icon', sortable: false},
          {text: "My Notifications", value:'message', sortable: false, class:'black--text font-weight-bold title'},
          {text: "", value:'time', sortable: false}
        ],
        
      }
    
    },
    created () {
      this.$vuetify.theme.light = true
       this.$store.dispatch("NotificationsCount")
        .then(()=>{
        })
        .catch(()=>{
        })

         this.$store.dispatch("Notifications")
        .then(()=>{
        })
        .catch(()=>{
        })
    },
    computed:{
       userById(){
          let user= this.$store.state.auth.logindetails.data
          user.date_created = user.date_created.slice(0, 19).replace('T', ' ')
          return user
        },
        Count(){
           return this.$store.state.notifications.count
        },
         RecentNotifications(){
          return this.$store.state.notifications.recentnotifications
        },
    },
    methods:{
      logout(){
        this.$store.dispatch("AUTH_LOGOUT")
        .then(()=>{
            window.localStorage.removeItem("vuex")
            this.$router.push('/login');
        })
        .catch(()=>{
        })
      },
      getImageUrl(url){
        if(url!==""||url!=='undefined'||url!==null){
            return url
        }else{
            return('/pics.svg')
        }
      },
      markNotification(){
         this.notificationDialog= true
         if(this.Count > 0){
            this.$store.dispatch("MarkNotifications")
           .then(()=>{ 
                 this.$store.dispatch("NotificationsCount")
            })
            .catch(()=>{
          });
         }
         
      },
      viewNotifications(){
        this.notificationDialog= false
        this.$router.push('/notifications')
      }
    }
  }
</script>
<style scoped>
.v-textfield input{
  font-size: 0.8em !important;
}
#badge{
  height: 10px !important;
  width: 10px !important;
}
.v-list .v-list-item--active{
  border-right: 5px #48c074 solid;
}

.v-list-item{
  text-decoration: none;
}
.text-color{
  color:#48c074;
}
</style>
     